import { defineComponent as _defineComponent } from 'vue'
import AppLoading from '@/components/ui/AppLoading.vue';
import { getErrorMessage } from '@/helpers/error-helpers';
import CertificadoService from '@/services/CertificadoService';
import { useMutation } from '@tanstack/vue-query';
import { CertificadoInput } from '@/../common/types/certificado/CertificadoInput';


export default /*#__PURE__*/_defineComponent({
  __name: 'EscanearPresenca',
  props: {
    token: null
  },
  setup(__props: any) {

const { token } = __props as {
    token: string;
};



const { data, isPending, error, mutate } = useMutation({
    mutationFn: (params: CertificadoInput) => CertificadoService.post(params)
})

mutate({ token })


return { __sfc: true,data, isPending, error, mutate, AppLoading, getErrorMessage }
}

})